import './lncanada10/style';
import FormStructure from './lncanada10/form_structure';

export default FormStructure;